import React from "react";
import { Link } from "react-router-dom";
import { Palette, Sparkles } from "lucide-react";
import { WaveTop, WaveBottom, Blob } from "@/components/Deco";
import { Reveal } from "@/components/Reveal";

export default function BookCta({ variant = "pink" }) {
  return (
    <section className="relative" data-testid="book-cta">
      <WaveTop color="#8754D9" />
      <div className="bg-purple text-white relative overflow-hidden">
        <Blob className="absolute -top-10 -left-10 w-56 h-56 opacity-30 animate-float" color="#FFD447" />
        <Blob className="absolute -bottom-16 -right-10 w-64 h-64 opacity-30 animate-float" color="#28BCEB" />
        <div className="section py-16 text-center relative">
          <Reveal>
            <p className="font-accent text-3xl text-sunshine mb-2">Let’s add a little colour to your celebration.</p>
            <h2 className="font-heading text-3xl sm:text-5xl font-700 mb-4">Ready to book Paint With Tay?</h2>
            <p className="max-w-2xl mx-auto text-white/90 text-lg mb-8">
              Pick your event, choose an available time, and tell Tay about your party. It only takes a couple of minutes.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/book" className="btn-yellow text-lg" data-testid="cta-book-btn">
                <Palette className="w-5 h-5" /> Book Paint With Tay
              </Link>
              <Link to="/gallery" className="btn-white text-lg" data-testid="cta-gallery-btn">
                <Sparkles className="w-5 h-5" /> See the Magic
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
      <WaveBottom color="#8754D9" />
    </section>
  );
}
